import { useCallback, useEffect, useRef, useState } from "react";
import NewMyOrder from "./ApprovalOrder";
import { useSelector, useDispatch } from "react-redux";
import navOperations from "../../../../redux/Navigation/operations";
import pendingOrderOperations from 'redux/PendingOrder/operations';
import RejectedBee from "../../../assets/images/PenndingApproval/Rejected Bee.png";
import WarningBee from "../../../assets/images/PenndingApproval/Warning Bee.png";
import CommentBee from "../../../assets/images/PenndingApproval/Comment Bee.png";
import ConfirmationBee from "../../../assets/images/PenndingApproval/Confirmation Bee.png";
import SuccessBee from "../../../assets/images/SuccessBee.svg";
import navSelector from "../../../../redux/Navigation/selectors";
import userProfileSelectors from 'redux/UserProfile/selectors';
import { setIsOrderApprovalComplete, setIsOrderCanceled } from "redux/PendingOrder/action";
import { CONSTANTS } from "client/utils/constants";
import ApprovalDispatch from "Store/OrderManagement/Approval/ApprovalDispatch";
import { setIsItemAndOrderLevelApproval } from "Store/OrderManagement/Approval/ApprovalAction";
import { setIsOverrideActionApplicable, setOrderApprovalRequest } from "Store/Component/OrderApproval/OrderApprovalAction";
import { useNavigate, useParams } from "react-router-dom";
import OrderDispatch from "Store/OrderManagement/Order/OrderDispatch";
import permissions, { isAuthorized } from "client/utils/Permissions";
import { getBulkOrderById } from "Store/OrderManagement/BulkOrderById/BulkOrderByIdAction";
import { setOrderById } from "Store/OrderManagement/Order/OrderAction";
import { AlertNotificationDispatch } from "Store/AlertNotification/AlertNotificationDispatch";
import { approvalPopupDisplay, defaultBreadcrumList, popupInitialData } from "utils";
import { expenditureColumn } from "client/utils/ExpenditureColumn";
import { setActiveHeader } from 'redux/MyOrder/action';
import RequisitionAction from 'Store/Component/Requisition/RequisitionAction';

const ApprovalOrderContainer = (props: any) => {
  const { isBulkOrder } = props
  const [comment, setComment] = useState("");
  const [mobile, setMobile] = useState(false);
  const [commentError, setCommentError] = useState(false);
  const [headerNavItem, setHeaderNavItem] = useState("home");
  const [approvalAction, setApprovalAction] = useState<any>({
    actionby: "",
    returnOrderconfirmation: "",
    rejectOrderconfirmation: "",
    approveOrderconfirmation: "",
    submitOrderconfirmation: "",
    cancelorder: ""
  });

  const dispatch = useDispatch();
  const dispatchCapitaleaseExpenditureData = ApprovalDispatch.dispatchCapitaleaseExpenditureData(dispatch)
  const dispatchItemAndOrderLevelApproval = ApprovalDispatch.dispatchItemAndOrderLevelApproval(dispatch)
  const getOrderDetailById = OrderDispatch.dispatchGetOrderById(dispatch);
  const dispatchSetIsAlertNotificationApiCalled = AlertNotificationDispatch.dispatchSetIsAlertNotificationApiCalled(dispatch);
  const cancelOrderRequest = pendingOrderOperations.dispatchCancelOrderRequest(dispatch);
  const dispatchActionPopupValue = pendingOrderOperations.dispatchActionPopup(dispatch);

  const navigate = useNavigate();
  let { pagename } = useParams();
  const dispatchNav = navOperations.dispatchNav(dispatch);

  const {
    orderByIdValue,
    orderApprovalRequest,
    isItemAndOrderLevelApproval,
    requestApproverActionData,
    capitalLeaseExpenditureData,
    approvalRequestOption,
    headerNav,
    quantityApprovalOption,
    selectedOptionsSubmit,
    userDetails,
    isOverrideActionapplicable,
    bulkOrderbyIdValue,
    activeNavigation,
    isOrderCanceled,
    actionPopupValue
  }: any = useSelector((state: any) => (
    {
      orderByIdValue: state.OrderReducer.orderByIdData,
      orderApprovalRequest: state.OrderApprovalReducer.orderApprovalRequest,
      isItemAndOrderLevelApproval: state.ApprovalReducer.isItemAndOrderLevelApprovalData,
      requestApproverActionData: state.ApprovalReducer.requestApproverActionData,
      capitalLeaseExpenditureData: state.ApprovalReducer.capitalLeaseExpenditureData,
      approvalRequestOption: state.OrderApprovalReducer.approvalRequestOption,
      headerNav: navSelector.GetHeaderNav(state),
      quantityApprovalOption: state.OrderApprovalReducer.quantityApprovalOption,
      selectedOptionsSubmit: state.OrderApprovalReducer.selectedOptionsSubmit,
      userDetails: userProfileSelectors.getUserDetails(state),
      isOverrideActionapplicable:state.OrderApprovalReducer.isOverrideActionapplicable,
      bulkOrderbyIdValue: state.BulkOrdeByIdReducer.bulkOrderbyIdValue,
      activeNavigation: state.nav.nav,
      isOrderCanceled: state.PendingOrder.isOrderCanceled,
      actionPopupValue: state.PendingOrder.actionPopupValue,
    }));


  useEffect(()=>{
    if(bulkOrderbyIdValue && isBulkOrder){
      let requestsTemp: any = []
      const bulkOrderbyIdValueTemp = JSON.parse(JSON.stringify(bulkOrderbyIdValue))
      bulkOrderbyIdValueTemp?.searchCriteria?.forEach((item: any) => {
        requestsTemp = [...requestsTemp, ...(item.requests ?? [])]
      })
      bulkOrderbyIdValueTemp.requests = requestsTemp
      bulkOrderbyIdValueTemp.totalItems = requestsTemp?.length
      delete bulkOrderbyIdValueTemp?.searchCriteria
      dispatch(setOrderById(bulkOrderbyIdValueTemp))
    }
  }, [bulkOrderbyIdValue])  

  useEffect(() => {
    const resizeFun = () => {
      if (window.innerWidth < 600) {
        setMobile(true)
      }
      else {
        setMobile(false);
      }
    }
    resizeFun();
    window.addEventListener('resize', resizeFun)
    return () => window.removeEventListener('resize', resizeFun)
  }, []);

  useEffect(() => {
    dispatchCapitaleaseExpenditureData({ id: 1 });
  }, []);

  let { id } = useParams();
  useEffect(() => {
    if (id != undefined && userDetails?.permissions?.length > 0) {
      if(isAuthorized(permissions.ApprovalsView) && !isBulkOrder){
        getOrderDetailById(id);
      } else if(isAuthorized(permissions.ApprovalsView) && isBulkOrder){
        dispatch(getBulkOrderById({
          orderId: id,
          isEdit: false
        }))
      } else{
        navigate('/ordermanagement/blank');
      } 
    }
  }, [id, userDetails?.permissions])

  const getNextApprover = () => {
    if (!orderByIdValue?.approvalHistory?.[0]?.approvalList) {
      return null;
    }
    for (let i=0; i <= orderByIdValue?.approvalHistory[0]?.approvalList?.length; i++){
      if(orderByIdValue?.approvalHistory[0]?.approvalList[i]?.status == CONSTANTS.ORDER_STATUS.PENDING_APPROVAL){
        return orderByIdValue?.approvalHistory[0]?.approvalList[i]?.assignedUserEmail
      }
    }
    return null;
  }

  useEffect(()=>{
    if (orderByIdValue?.hasOwnProperty('approvalHistory')) {
    if(!isBulkOrder){
      if((userDetails?.emailId?.toLowerCase() == getNextApprover()?.toLowerCase() && getNextApprover()?.toLowerCase() != undefined && getNextApprover()?.toLowerCase() != null)){
        dispatch(setIsOverrideActionApplicable(false))
      } else if ((userDetails?.emailId?.toLowerCase() != getNextApprover()?.toLowerCase()) && getNextApprover()?.toLowerCase() != undefined && getNextApprover()?.toLowerCase() != null && (isAuthorized(permissions.SuperApproval_Approvals) || isAuthorized(permissions.ViewAllPendingApprovals))){
        dispatch(setIsOverrideActionApplicable(true))
      } else{
        navigate('/ordermanagement/requisitionorderdetail/' + id + '/home')
      }
    } else {
      if((userDetails?.emailId?.toLowerCase() == getNextApprover()?.toLowerCase()) && getNextApprover()?.toLowerCase() != undefined && getNextApprover()?.toLowerCase() != null){
        dispatch(setIsOverrideActionApplicable(false))
      } else if ((userDetails?.emailId?.toLowerCase() != getNextApprover()?.toLowerCase()) && getNextApprover()?.toLowerCase() != undefined && getNextApprover()?.toLowerCase() != null && (isAuthorized(permissions.SuperApproval_Approvals) || isAuthorized(permissions.ViewAllPendingApprovals))){
        dispatch(setIsOverrideActionApplicable(true))
      } else{
        navigate('/ordermanagement/bulkorderdetail/' + id + '/home')
      }
    }
  }
  },[orderByIdValue, bulkOrderbyIdValue])

  useEffect(() => {
    setHeaderNavItem(headerNav);
  }, [headerNav]);

  const wrapperRef = useRef<any>(null);

  useEffect(() => {
      document.getElementsByClassName('content-wrapper')[0].scrollTop = 0;
  }, [activeNavigation]);

  const [Popupcontent, setPopupcontent] = useState<any>({
    ...popupInitialData,
    isDialogVisible: false // Ensure popup is not visible on initial load
  });

  const onChangeComment = (_e: any, text: string) => {
    if (text.length > 500) {
      setCommentError(true);
    } else {
      setCommentError(false);
    }
    setComment(text);
  };

  const popupOutlinebtnOnclick = (item: any) => {
    if (item !== "") {
      dispatchNav(headerNavItem);
      dispatchSetIsAlertNotificationApiCalled(true)
      dispatch(setIsItemAndOrderLevelApproval(null))
      navigate('/ordermanagement');
    }
    if (actionPopupValue.actionby === "CancelOrderBtn") {
      dispatchActionPopupValue({})
      isOrderCanceled.approval = undefined;
      if(pagename === CONSTANTS.PAGE_NAME.REQUISITION){
        dispatchNav('Customer My Orders')
      }else if(pagename == "Bulk Order"){
        dispatchNav('Bulk Orders')
      }else{
        dispatchNav('Home')
      }
      navigate('/ordermanagement');
    }
    hideDialog();
  };

  const erroOrderConfirmation = (
    <>
      <p>
        <b>{CONSTANTS.LEADR_ORDER_NUMBER}</b> : {orderByIdValue?.orderId}
      </p>
      <p>Something went wrong..! Please try again later</p>
    </>
  );

  useEffect(() => {
    let beeImage = {
      SuccessBee: SuccessBee,
      RejectedBee: RejectedBee
    }
    approvalPopupDisplay(setPopupcontent, Popupcontent, isItemAndOrderLevelApproval, approvalAction, setIsOrderApprovalComplete, beeImage, erroOrderConfirmation)
  }, [isItemAndOrderLevelApproval]);

  useEffect(() => {
    if (isOrderCanceled?.approval !== undefined && actionPopupValue.actionby === "CancelOrderBtn") {
      if (isOrderCanceled.approval) {
        dispatch(RequisitionAction.setIsChangesOccured(false))
        let cancelorder = "Order Cancelled Successfully"
        setApprovalAction({
          ...approvalAction,
          actionby: actionPopupValue.actionby,
          cancelorder
        });
      }
      else {
        let cancelorder = "Order Cancelled Failed"
        setApprovalAction({
          ...approvalAction,
          actionby: actionPopupValue.actionby,
          cancelorder
        });
      }
    }
  }, [isOrderCanceled?.approval, actionPopupValue.actionby])

  useEffect(() => {
    if (approvalAction.actionby === "CancelOrderBtn") {
      setPopupcontent({
        ...Popupcontent,
        titleImg: RejectedBee,
        title: "Success",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: (
          <>
            <p>{approvalAction.cancelorder}</p>
          </>
        ),
        primaryBtnText: "",
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
        isCommentboxVisible: false,
        isCommentBoxRequire: false,
        isCompletedReportVisible: false,
        outlineBtnnavigateTo: (headerNavItem === "Customer My Orders") ? "Customer My Orders" : headerNavItem,
        primaryBtnnavigateTo: "",
        href: "/ordermanagement",
        actionby: ""
      });
    }
  }, [approvalAction]);

  const popupPrimarybtnOnclick = (
    item: any,
    comments: string,
    actionby: string,
    value: any,
    returnOrderconfirmation: any,
    rejectOrderconfirmation: any,
    approveOrderconfirmation: any,
    submitOrderconfirmation: any
  ) => {

    if (actionby === "CancelOrderBtn") {
      cancelOrderRequest({ orderId: orderByIdValue?.orderId, savedBy: userDetails?.emailId, comments: comments });
      dispatchActionPopupValue({
        actionby: actionby
      });
      hideDialog();
    } else if (actionby === "CancelApprovalBtn") {
      if (item !== "") {
        dispatchNav(item);
        navigate('/ordermanagement');
      }
      hideDialog();
    } else {
      setApprovalAction({
        ...approvalAction,
        actionby,
        returnOrderconfirmation,
        rejectOrderconfirmation,
        approveOrderconfirmation,
        submitOrderconfirmation
      });

      dispatch(setIsItemAndOrderLevelApproval(null))
      orderApprovalRequest.approverActionId = value;
      orderApprovalRequest.comment = comments;
      orderApprovalRequest.isApprovalOverride = isOverrideActionapplicable
      dispatch(setOrderApprovalRequest(orderApprovalRequest));
      dispatchItemAndOrderLevelApproval(orderApprovalRequest)
      hideDialog();
    }
  };

  const hideDialog = useCallback(
    () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
    [Popupcontent]
  );

  const returnOrderReq = (returnOrdersubtext: any, Comment: any) => {
    const result = requestApproverActionData.filter(
      (approverAction: any) => approverAction?.key === "Request More Info"
    );
    setPopupcontent({
      ...Popupcontent,
      comment: Comment,
      titleImg: CommentBee,
      title: "RETURN ORDER TO REQUESTOR",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: returnOrdersubtext,
      primaryBtnText: "Return",
      outlineBtnText: "Cancel",
      isSingleConfirmationBtn: false,
      isCommentboxVisible: true,
      isCommentBoxRequire: true,
      isCompletedReportVisible: false,
      outlineBtnnavigateTo: "",
      primaryBtnnavigateTo: "",
      actionby: "ReturnSubmitbtn",
      value: result[0]?.value,
    });
  };

  const rejectOrderReq = (rejectOrdersubtext: any, Comment: any) => {
    const result = requestApproverActionData.filter(
      (approverAction: any) => approverAction?.key === "Reject"
    );
    setPopupcontent({
      ...Popupcontent,
      comment: Comment,
      titleImg: CommentBee,
      title: "REJECT ORDER",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: rejectOrdersubtext,
      primaryBtnText: "Reject",
      outlineBtnText: "Cancel",
      isSingleConfirmationBtn: false,
      isCommentboxVisible: true,
      isCommentBoxRequire: true,
      isCompletedReportVisible: false,
      outlineBtnnavigateTo: "",
      primaryBtnnavigateTo: "",
      actionby: "RejectSubmitBtn",
      value: result[0]?.value,
    });
  };

  const approveOrderReq = (approveOrdersubtext: any, Comment: any) => {
    const result = requestApproverActionData.filter(
      (approverAction: any) => approverAction?.key === "Approve"
    );
    setPopupcontent({
      ...Popupcontent,
      comment: Comment,
      titleImg: WarningBee,
      title: "APPROVE ORDER",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: approveOrdersubtext,
      primaryBtnText: "Approve",
      outlineBtnText: "Cancel",
      isSingleConfirmationBtn: false,
      isCommentboxVisible: true,
      isCommentBoxRequire: false,
      isCompletedReportVisible: false,
      outlineBtnnavigateTo: "",
      primaryBtnnavigateTo: "",
      actionby: "ApproveSubmitBtn",
      value: result[0]?.value,
    });
  };

  const cancelOrderReq = (cancelOrdersubtext: any) => {
    setPopupcontent({
      ...Popupcontent,
      titleImg: RejectedBee,
      title: "CANCEL ORDER",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: cancelOrdersubtext,
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      isSingleConfirmationBtn: false,
      isCommentboxVisible: true,
      isCommentBoxRequire: true,
      isCompletedReportVisible: false,
      outlineBtnnavigateTo: "",
      primaryBtnnavigateTo: (headerNavItem === "Customer My Orders") ? "Customer My Orders" : headerNavItem,
      actionby: "CancelOrderBtn",
      href: "/ordermanagement",
    });
    dispatch(setActiveHeader(CONSTANTS.ACTIVE_HEADER.HOME))
  };

  const cancelApprovalReq = (cancelApprovalsubtext: any) => {
    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: "CONFIRMATION",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: cancelApprovalsubtext,
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      isSingleConfirmationBtn: false,
      isCommentboxVisible: false,
      isCommentBoxRequire: false,
      isCompletedReportVisible: false,
      outlineBtnnavigateTo: "",
      primaryBtnnavigateTo: "Home",
      actionby: "CancelApprovalBtn",
    });
  };

  const submitOrderReq = (approveOrdersubtext: any) => {
    setPopupcontent({
      ...Popupcontent,
      titleImg: WarningBee,
      title: "SUBMIT APPROVAL",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: approveOrdersubtext,
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      isSingleConfirmationBtn: false,
      isCommentboxVisible: false,
      isCommentBoxRequire: false,
      isCompletedReportVisible: false,
      outlineBtnnavigateTo: "",
      primaryBtnnavigateTo: "Home",
      actionby: "SubmitOrderBtn",
      //value: result[0]?.value,
    });
  };

  const disableSubmitOrder = () => {    
    if (orderByIdValue?.quantity === selectedOptionsSubmit?.length || orderByIdValue?.totalItems === selectedOptionsSubmit?.length) {
      return false;
    } else {
      return true;
    }
  };

  const disableApproveOrder = () => {
    if (commentError === true) {
      return true;
    } else {
      return false;
    }
  };

  const handleClickBack = () => {
    dispatchNav(headerNavItem);
    navigate('/ordermanagement');
  }

  const getUserRoles = () => {
    let roles = userDetails?.roles?.map((role: any) => role.roleName)
    return roles
  }

  return (
    <NewMyOrder
      approvalRequestOption={approvalRequestOption}
      expenditureColumn={expenditureColumn}
      capitalLeaseExpenditureData={capitalLeaseExpenditureData}
      orderByIdValue={orderByIdValue}
      breadcrumlist={defaultBreadcrumList(dispatchNav, headerNavItem, navigate, "Approve Request")}
      comment={comment}
      onChangeComment={onChangeComment}
      returnOrderReq={returnOrderReq}
      rejectOrderReq={rejectOrderReq}
      approveOrderReq={approveOrderReq}
      cancelOrderReq={cancelOrderReq}
      cancelApprovalReq={cancelApprovalReq}
      submitOrderReq={submitOrderReq}
      Popupcontent={Popupcontent}
      popupPrimarybtnOnclick={popupPrimarybtnOnclick}
      popupOutlinebtnOnclick={popupOutlinebtnOnclick}
      hideDialog={hideDialog}
      commentError={commentError}
      disableSubmitOrder={disableSubmitOrder}
      disableApproveOrder={disableApproveOrder}
      handleClickBack={handleClickBack}
      mobile={mobile}
      wrapperRef={wrapperRef}
      quantityApprovalOption = {quantityApprovalOption}
      isOverrideActionapplicable = {isOverrideActionapplicable}
      isBulkOrder={isBulkOrder}
      userDetails={userDetails}
      getUserRoles={getUserRoles}
    />
  );
};

export default ApprovalOrderContainer;
